import { useCallback, useEffect, useState } from "react";
import { getUsuariosSinPedir } from "../service/sinPedirService";

export function useUsuariosSinPedir(filtros) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { desde, hasta } = filtros;
  // El backend exige desde/hasta y que hasta >= desde: no pegamos si el rango es inválido.
  const rangoValido = Boolean(desde && hasta && hasta >= desde);

  const fetchData = useCallback(async () => {
    if (!rangoValido) {
      setData([]);
      setError(null);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await getUsuariosSinPedir(filtros);
      setData(res || []);
    } catch (err) {
      setError(err);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [filtros, rangoValido]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, rangoValido, refresh: fetchData };
}
